import React from 'react';
import { Pane } from 'evergreen-ui';
import { PaintingItem } from './PaintingItem';

import {useAPI} from '../../Api';

export function PaintingWizard(props) {

    let API = useAPI()
       return (
        <Pane  display={'flex'} flexFlow={"row wrap"} height={"400px"} overflowY={"scroll"}>

            {API.resources.paintColours.map((element,i) => {
                return (
           
                        <PaintingItem  key={i}
                          selected={props.getColor == element.Itemname}
                           onSelect={() => { props.setColor(element.Itemname); }} option={element} />
           
                );
            })}
        </Pane>
    );
}
